import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Container } from "react-bootstrap";
import Profile from "../../assets/images/profile.png"
import BottomIcon from "../../assets/images/card-bottom.svg"
import Icon1 from "../../assets/images/icon1.svg"
import Icon2 from "../../assets/images/cone.svg"
import Icon3 from "../../assets/images/ripple.svg"
import Icon4 from "../../assets/images/eth.svg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import "./earnInterest.css"
import Navbar from "../shared/navbar/navbar";
import InterestCard from "./earnInterestCard";
import { getWalletLists, beforeWallets, getSymbolsLists } from "../../redux/wallet/wallet.action"
import { getBalanceOfToken } from '../../utils/web3'
import { connect } from 'react-redux';
import LockPeriod from "./lockPeriod";
import ProfitPlannings from "./profitPlannings";
import { getCriteriaList } from "../../redux/user/user.action"
import ConfirmationLockModal from "./confirmationLockModal";
import MessageAlert from "../messageAlert/messageAlert";
import FullPageLoader from "../FullPageLoader/FullPageLoader";
import { ENV } from '../../config/config'
import {
    getCurrencyStats,
    beforeCurrencyStats
  } from "../../redux/dashboard/dashboard.action";



const EarnInterest = (props) => {
    const { tokenWallets } = ENV.getUserKeys()
    const [tokenBal, setTokenBalance] = useState()
    const [showConfirmationModal, setShowConfirmationModal] = useState(false)
    const [messageAlert, setShowMessageAlert] = useState(false)
    const [profitPlan, setProfitPlan] = useState(null)
    const [profit, setProfit] = useState()
    const [amnt, setAmnt] = useState()
    const [gasFee, setGasFee] = useState()
    const [isLockedConfirmed, setIsLockedConfirmed] = useState(false)

    const [fullPageLoader, setFullPageLoader] = useState(true)
    const [wallets, setWallets] = useState([])
    const [bronzeMinInvestment, setBronzeMinInvestment] = useState([])
    const [currenciesArray, setCurrenciesArray] = useState([])
    const [criteriaList, setCriteriaList] = useState(null)
    const [searchSymbolText, setSearchSymbolText] = useState()
    const [selectedToken, setSelectedToken] = useState(null)
    const [selectedPlanCriteria, setSelectedPlanCriteria] = useState(null)

    const [step, setStep] = useState(1) //1-currency selection, 2-plan selection 3- profit selection
    const [bonus, setBonus] = useState()
    const [promoCodeUsed, setPromoCodeUsed] = useState()

    useEffect(() => {
        // let token = localStorage.getItem("accessToken")
        // if (token) {
            props.beforeWallets()
            props.getSymbolsLists()
            props.getWalletLists()
            props.getCriteriaList()
            props.getCurrencyStats()
        // }
    }, [])

    useEffect(() => {
        if (isLockedConfirmed) {
            // setAmount(0)
            setStep(1)
            setIsLockedConfirmed(false)
            // props.setIsLockedConfirmed(false)
        }
    }, [isLockedConfirmed])

    useEffect(() => {
        if (props.wallets.getSymbolsAuth) {
            setCurrenciesArray(props.wallets.symbols)
        }
    }, [props.wallets.getSymbolsAuth])

    useEffect(() => {
        if (props.dashboard.listStatsGraphAuth) {
          if (props.dashboard.listStatsData.availableProfitStats[0]) {
            let { availableProfit, lockedProfit } = props.dashboard.listStatsData.availableProfitStats[0]
            let profit = parseFloat(availableProfit > 0 ? availableProfit : 0) + parseFloat(lockedProfit > 0 ? lockedProfit : 0)
            setProfit(profit)
            props.beforeCurrencyStats()
          }
          else {
            setProfit(0)
          }
        }
      }, [props.dashboard.listStatsGraphAuth])

    useEffect(() => {
        if (props.wallets.getWalletsAuth) {
            props.beforeWallets()
            setWallets(props.wallets.wallets)
            setSelectedToken(props.wallets.wallets[0])
            setBronzeMinInvestment(props.wallets.bronzeMinInvestment)

            // Get User Wallet Balance
            let wallet = props.wallets.wallets[0];
            fetchBalance(wallet)
        }
    }, [props.wallets.getWalletsAuth])

    const fetchBalance = async (wallet) => {
        const balance = await getBalanceOfToken(wallet.networkId, wallet.walletAddress, tokenWallets.ethereum)
        setFullPageLoader(false)
        setTokenBalance(balance)
    }

    useEffect(() => {
        if (props.user.criteriaListAuth) {
            const { criteria } = props.user.criteriaList
            setCriteriaList(criteria)
        }
    }, [props.user.criteriaListAuth])

    // useEffect(() => {
    //     if (props.user?.userBalance) {
    //         setTokenBalance(props.user?.userBalance)
    //     }
    // }, [props.user.userBalance])

    useEffect(() => {
        props.beforeWallets()
        let payload = { symbolText: searchSymbolText }
        let token = localStorage.getItem("accessToken")
        if (token) {
            props.getWalletLists(payload)
        }
    }, [searchSymbolText])

    const hideModal = () => {
        fetchBalance(selectedToken)
        setShowMessageAlert(false)
    }

    return (
            fullPageLoader ?
                <div>
                    <FullPageLoader />
                </div>
                :
        <div className="earn-interest">
            <div className="earn-interest-details wallet-details p-3">
                {/* <div className="d-flex justify-content-end top-head flex-wrap pt-75">
                    <Navbar />
                </div> */}

                <Container>
                    <h2>Earn Interest</h2>
                    <Row className="details">
                        <Col xxl={3} xl={4} md={6}>
                            <div className={`detais-cards ${step === 1 ? "active" : ''}`}>
                                <div className="d-flex align-items-center flex-sm-nowrap flex-wrap">
                                    <span className="count">01</span>
                                    <strong>Currency</strong>
                                </div>
                            </div>
                        </Col>
                        <Col xxl={3} xl={4} md={6}>
                            <div className={`detais-cards ${step === 2 ? "active" : ''}`}>
                                <div className="d-flex align-items-center flex-sm-nowrap flex-wrap">
                                    <span className="count">02</span>
                                    <strong>Earn interest plan</strong>
                                </div>
                            </div>
                        </Col>
                        <Col xxl={3} xl={4} md={6}>
                            <div className={`detais-cards ${step === 3 ? "active" : ''}`}>
                                <div className="d-flex align-items-center flex-sm-nowrap flex-wrap">
                                    <span className="count">03</span>
                                    <strong>Set amount</strong>
                                </div>
                            </div>
                        </Col>
                        <Col xxl={3} xl={4} md={6}>
                            <div className={`detais-cards ${step === 4 ? "active" : ''}`}>
                                <div className="d-flex align-items-center flex-sm-nowrap flex-wrap">
                                    <span className="count">04</span>
                                    <strong>Confirmation</strong>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {
                        step === 1 ?
                            <>
                                <div className="d-flex justify-content-between align-items-center flex-wrap searching">
                                {((parseFloat(tokenBal) + parseFloat(profit)) < bronzeMinInvestment ) ?
                                <h4 className="mb-4 text-white" >
                                    Please upgrade to Bronze account by holding at least {bronzeMinInvestment} TRI to receive interest on your funds.
                                </h4>
                                :
                                <h2 className="mb-4">
                                Please click on next button to choose plan
                            </h2>
                                    }
                                </div>
                                <Row className="interst-cards">
                                            <>
                                                {
                                                    wallets.map((wallet) => {
                                                        return (
                                                            <Col className="mb-4" xxl={3} xl={4} md={6}>
                                                                <div className={wallet?._id === selectedToken?._id ? "active-card " : ''}>
                                                                {/* <div className="active-card"> */}
                                                                    <InterestCard wallet={wallet} setSelectedToken={setSelectedToken} bronzeMinInvestment={bronzeMinInvestment} 
                                                                    selectedToken={selectedToken} tokenBal={tokenBal} profit={profit}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        )
                                                    })
                                                }
                                                {
                                                    !wallets.length ?
                                                        <div className="not-found"><p className="text-white">Wallet is not avilable.</p></div> : ''
                                                }
                                            </>
                                </Row>
                            </> : ''
                    }
                </Container>
                {
                    (step === 1) ?
                        <div className="d-flex justify-content-end container">
                            {/* <button className="btn-triage-div btn-triage me-4 mb-3 mb-md-0 me-3" ><span>Deposit</span></button> */}
                            <button className="btn-triage-div btn-triage mb-3 mb-md-0 " onClick={() => setStep(2)}
                             disabled={
                                selectedToken && ((parseFloat(tokenBal) + parseFloat(profit)) >= bronzeMinInvestment) ? false : true 
                            }><span>Next</span></button>
                        </div> : ''
                }
            </div>
            {
                step === 2 ?
                    <LockPeriod setStep={setStep} selectedToken={selectedToken}
                        setSelectedPlanCriteria={setSelectedPlanCriteria} 
                        profit={profit} tokenBal={tokenBal}
                        /> : ''
            }
            {
                step === 3 || step === 4 ?
                    <ProfitPlannings setPromoCodeUsed={setPromoCodeUsed} setBonus={setBonus} selectedProfitPlan={profitPlan} setSelectedProfitPlan={setProfitPlan} amount={amnt} setAmount={setAmnt} setGasFee={setGasFee} wallets={wallets} setShowConfirmationModal={setShowConfirmationModal} setStep={setStep} selectedToken={selectedToken} selectedPlanCriteria={selectedPlanCriteria} tokenBal={tokenBal} profit={profit}/> : ''
            }

            {
                showConfirmationModal &&
                <ConfirmationLockModal
                    promoCodeUsed={promoCodeUsed}
                    bonus={bonus}
                    setTokenBalance={setTokenBalance}
                    show={showConfirmationModal}
                    onHide={() => setShowConfirmationModal(false)}
                    selectedProfitPlan={profitPlan}
                    setSelectedProfitPlan={setProfitPlan}
                    amount={amnt}
                    setAmount={setAmnt}
                    setStep={setStep}
                    selectedToken={selectedToken}
                    setSelectedToken={setSelectedToken}
                    setShowConfirmationModal={setShowConfirmationModal}
                    selectedPlanCriteria={selectedPlanCriteria}
                    isLockedConfirmed={isLockedConfirmed}
                    setIsLockedConfirmed={setIsLockedConfirmed}
                    messageAlert={messageAlert}
                    setShowMessageAlert={setShowMessageAlert}
                    walletsCall={props.getWalletLists}
                    tokenBal={tokenBal}
                    gasFee={gasFee}
                />
            }

            <MessageAlert
                type="success"
                greeting="Great!"
                description={"You have successfully locked the selected amount. Check your dashboard daily for the available rewards."}
                show={messageAlert}
                // onHide={() => setShowMessageAlert(false)}
                onHide={() => hideModal(false)}
            />

        </div>
    )
}

const mapStateToProps = (state) => ({
    wallets: state.wallets,
    dashboard: state.dashboard,
    user: state.user
})

export default connect(mapStateToProps, { getWalletLists, beforeWallets, getSymbolsLists, getCriteriaList,getCurrencyStats,beforeCurrencyStats })(EarnInterest)